 // Import the functions you need from the SDKs you need
 import { initializeApp } from "firebase/app";
 import { getFirestore } from "firebase/firestore";
 import { getAnalytics } from "firebase/analytics";
  import { getStorage } from "firebase/storage";
  import { getAuth } from "firebase/auth";
  const firebaseConfig = {

    apiKey: "AIzaSyAwdDHlwGym3NcAqklDeLzvMQV4GWOxv0A",
  
    authDomain: "shard-48d73.firebaseapp.com",
  
    databaseURL: "https://shard-48d73-default-rtdb.firebaseio.com",
  
    projectId: "shard-48d73",
  
    storageBucket: "shard-48d73.firebasestorage.app",
  
    messagingSenderId: "524963734275",
  
    appId: "1:524963734275:web:2b38ad03ba7294e5483f36",
  
    measurementId: "G-JR0ERD800P"
  
  };
  
 // Initialize Firebase
 
 const app = initializeApp(firebaseConfig);
 // Export firestore database
 // It will be imported into your react app whenever it is needed
 export const auth = getAuth(app);
 export const analytics = getAnalytics(app);
 export const storage = getStorage(app);
 export const db = getFirestore(app);